module.exports = __webpack_public_path__ + "static/img/JOSH-SMILLIE.ccb25db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JOSH-SMILLIE.jpg
// module id = lbYO
// module chunks = 0